import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import ServiceSide from "./ServiceSide";
import BgImg from "../../assets/portfolio/bg2.png";
// import BgImg from "../../assets/images/bg5.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import OurClients from "../OurClients/OurClients";
import SEOHERO from "../../assets/service/seo-hero.png";
import SEO from "../../assets/service/seo.png";
import {
  faSearch,
  faLink,
  faCogs,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";

import {
  faCode,
  // faLink,
  faWrench,
  // faMapMarkerAlt,
  faShoppingCart,
  // faSearch,
  faChartLine,
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet-async";
import FaqSeo from "../ServiceImp/FaqSeo";

const services = [
  {
    title: "On-Page SEO",
    icon: faCode,
  },
  {
    title: "Off-Page SEO",
    icon: faLink,
  },
  {
    title: "Technical SEO",
    icon: faWrench,
  },
  {
    title: "Local SEO",
    icon: faMapMarkerAlt,
  },
  {
    title: "E-commerce SEO",
    icon: faShoppingCart,
  },
  {
    title: "Keyword Research & Strategy",
    icon: faSearch,
  },
  {
    title: "Analytics & Reporting",
    icon: faChartLine,
  },
];

function SEOServices() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true }); // Initialize AOS with animation duration and animation trigger once
  }, []);

  const pillars = [
    {
      icon: faSearch, // Icon for Keyword Optimization
      title: "Keyword Optimization",
      description:
        "Identify and target high-traffic keywords to improve search engine visibility and drive organic traffic.",
      bgColor: "bg-blue-100",
    },
    {
      icon: faCogs, // Icon for Technical SEO
      title: "Technical SEO",
      description:
        "Optimize your website's architecture, load speed, mobile responsiveness, and crawlability for better performance.",
      bgColor: "bg-green-100",
    },
    {
      icon: faLink, // Icon for Link Building
      title: "Link Building",
      description:
        "Build high-quality backlinks from trusted sites to enhance domain authority and improve rankings.",
      bgColor: "bg-purple-100",
    },
    {
      icon: faMapMarkerAlt, // Icon for Local SEO
      title: "Local SEO",
      description:
        "Optimize your business for local search to attract nearby customers and improve Google Maps visibility.",
      bgColor: "bg-orange-100",
    },
  ];

  // seo data
  const organizationSchema = {
    "@context": "http://schema.org",
    "@type": "Organization",
    name: "Deetya Soft Pvt Ltd",
    description:
      "Boost your site’s traffic and visibility with Deetyasoft’s expert SEO services. Get on-page, off-page, local & technical SEO tailored to grow your business.",
    image:
      "https://deetyasoft.com/static/media/seo-hero.27bc48a7bf2bb4baa2fc.png",
    logo: "https://www.deetyasoft.com/images/logo.png",
    url: "https://www.deetyasoft.com",
    telephone: ["+91-9015350505", "+91-9717055088"],
    email: "info@deetyasoft.com",
    sameAs: [
      "https://www.linkedin.com/company/deetya-soft-private-limited",
      "https://www.facebook.com/deetyasoftprivatelimited",
      "https://www.instagram.com/deetyasoft",
      "https://www.youtube.com/@deetyasoft",
      "https://www.crunchbase.com/organization/deetyasoft",
    ],
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "FF‑06, First Floor, Mahaluxmi Square, Plot No. C‑1, Abhay Khand II, Indirapuram",
      addressLocality: "Ghaziabad",
      addressRegion: "Uttar Pradesh",
      postalCode: "201014",
      addressCountry: "IN",
    },
  };

  const contactSchema = {
    "@context": "http://schema.org",
    "@type": "Organization",
    url: "https://www.deetyasoft.com",
    contactPoint: [
      {
        "@type": "ContactPoint",
        telephone: "+91-981-862-7588",
        contactType: "technical support",
        areaServed: "IN",
      },
      {
        "@type": "ContactPoint",
        telephone: "+91-901-535-0505",
        contactType: "sales",
        areaServed: "IN",
      },
    ],
  };

  const reviewSchema = {
    "@context": "http://schema.org",
    "@type": "Review",
    author: {
      "@type": "Person",
      name: "Parshan ",
    },
    reviewBody:
      "Deetya Soft helps companies to enable effective business operations through custom web solutions, IVR, and cloud telephony services.",
    url: "https://www.deetyasoft.com/",
    description:
      "Deetya Soft Pvt Ltd offers services such as IVR systems, virtual phone numbers, toll-free numbers, call tracking, enquiry management, LMS, web solutions, VOIP, and cloud-based communication solutions.",
    datePublished: "2025-06-17",
    name: "Deetya Soft Pvt Ltd",
    reviewRating: {
      "@type": "Rating",
      worstRating: "1",
      ratingValue: "5",
      bestRating: "5",
    },
    itemReviewed: {
      "@type": "Organization",
      name: "Deetya Soft Pvt Ltd",
    },
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "What are SEO services and how do they help my business?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "SEO (Search Engine Optimization) services improve your website’s visibility on search engines like Google, helping you attract more organic traffic, leads, and sales.",
        },
      },
      {
        "@type": "Question",
        name: "Why should I choose Deetyasoft for SEO services in India?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Deetyasoft offers customized, data-driven SEO strategies including on-page, off-page, and local SEO to help you rank higher, drive traffic, and grow online.",
        },
      },
      {
        "@type": "Question",
        name: "How long does it take to see results from SEO?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "SEO is a long-term strategy. While minor improvements may appear in 1–2 months, significant traffic and ranking results typically take 3–6 months or more.",
        },
      },
      {
        "@type": "Question",
        name: "Do you offer local SEO for small businesses?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, we specialize in local SEO strategies that help small businesses appear in local search results, Google Maps, and near-me searches to attract nearby customers.",
        },
      },
      {
        "@type": "Question",
        name: "Are your SEO services affordable for startups and SMEs?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Absolutely! Deetyasoft offers flexible and affordable SEO plans tailored for startups, small businesses, and enterprises with transparent pricing and ROI focus.",
        },
      },
      {
        "@type": "Question",
        name: "What’s included in your SEO packages?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Our SEO packages include keyword research, website audit, technical SEO, content optimization, backlink building, and regular performance reporting.",
        },
      },
    ],
  };
  return (
    <>
      <Helmet>
        <title>SEO Services, Organic SEO Agency, Best SEO Company India </title>
        <meta
          name="description"
          content="Boost your site’s traffic and visibility with Deetyasoft’s expert SEO services. Get on-page, off-page, local & technical SEO tailored to grow your business."
        />
        <meta
          name="keywords"
          content="SEO services, Best SEO company in India, E-commerce SEO services India, SEO services in India, SEO agency India, SEO agency, SEO company, Affordable SEO services, Local SEO services, Professional SEO services, Small business SEO services, On‑page SEO services,"
        />
        <link rel="canonical" href="https://deetyasoft.com/seo-services" />

        {/* <!-- Facebook Meta Tags --> */}
        <meta property="og:locale" content="en_IN" />
        <meta property="og:type" content="article" />
        <meta property="og:url" content="https://deetyasoft.com/seo-services" />
        <meta
          property="og:title"
          content="SEO Services, Organic SEO Agency, Best SEO Company India "
        />
        <meta
          property="og:description"
          content="Boost your site’s traffic and visibility with Deetyasoft’s expert SEO services. Get on-page, off-page, local & technical SEO tailored to grow your business."
        />
        <meta
          property="og:image"
          content="https://deetyasoft.com/static/media/seo-hero.27bc48a7bf2bb4baa2fc.png"
        />
        <meta property="og:site_name" content="deetyasoft.com" />
        <meta
          property="article:publisher"
          content="https://www.facebook.com/deetyasoftprivatelimited"
        />

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:url"
          content="https://deetyasoft.com/content-management-system"
        />
        <meta
          name="twitter:title"
          content="SEO Services, Organic SEO Agency, Best SEO Company India "
        />
        <meta
          name="twitter:description"
          content="Boost your site's traffic and visibility with Deetyasoft’s expert SEO services. Get on-page, off-page, local & technical SEO tailored to grow your business."
        />
        <meta
          name="twitter:image"
          content="https://deetyasoft.com/static/media/seo-hero.27bc48a7bf2bb4baa2fc.png"
        />
        <meta name="twitter:site" content="@DeetyaSoft" />
        <meta name="twitter:creator" content="@DeetyaSoft" />

        <meta name="yandex-verification" content="31c730ea93a5a9cd" />
        <meta name="copyright" content="Deetyasoft" />
        <meta name="author" content="Deetyasoft" />
        <meta name="email" content="info@deetyasoft.com" />
        <meta name="Distribution" content="Global" />
        <meta name="rating" content="general" />
        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        <meta property="bingbot" content="index, follow " />
        <meta name="Yahoobot" content="index, follow" />
        <meta name="MSNbot" content="index, follow" />
        <meta name="googlebot-news" content="index, follow" />
        <meta name="audience" content="all" />
        <meta name="geo.placename" content="Noida, Uttar Pradesh, India" />
        <meta name="geo.region" content="IN-UP" />
        <meta name="geo.position" content="28.644800;77.373300" />
        <meta name="ICBM" content="28.644800, 77.373300" />
        <link rel="alternate" href="https://deetyasoft.com" hreflang="en-us" />
        <meta http-equiv="content-language" content="en-us" />
        <meta name="msvalidate.01" content="305155CCD42FD63B0A29555BBEE7CA03" />

        <script type="application/ld+json">
          {JSON.stringify(organizationSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(contactSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(reviewSchema)}
        </script>
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>
      {/*  */}
      <div className="relative bg-[#2f68a2] overflow-hidden pb-5 text-white">
        {/* Content */}
        <div className="relative z-20 max-w-7xl mx-auto  px-6 py-10 grid md:grid-cols-2 lg:gap-20 md:gap-10  items-start">
          {/* Left Side */}
          <div className="mt">
            <h1 className="text-3xl md:text-4xl font-bold leading-snug mb-4">
              SEO Services
            </h1>
            <p className="text-white/90 mb-6 text-base md:text-lg">
              In today's digital world, simply having a website is not enough.
              To truly succeed, your business needs to stand out on search
              engines like Google, Bing, and Yahoo. That's where our expert SEO
              services come in. We help you achieve top search rankings, drive
              targeted traffic, and increase online visibility, so your
              customers find you first.
            </p>
            <button
              className="bg-orange-500   hidden md:block hover:bg-orange-600 text-white px-5 py-3 rounded shadow-md transition"
              onClick={() => {
                const target = document.getElementById("bottomTarget");
                if (target) {
                  target.scrollIntoView({ behavior: "smooth", block: "start" });
                  // Optional offset tweak using window.scrollBy
                  setTimeout(() => {
                    window.scrollBy(0, -100); // scrolls 100px up after reaching the section
                  }, 600);
                }
              }}
            >
              Let's Get Started
            </button>
          </div>

          {/* Right Side Image */}
          <div className="flex justify-center">
            <img
              src={SEOHERO}
              alt="SEO Illustration"
              className="md:w-[90%] object-contain w-full max-w-lg animate-float"
            />
            {/* if image break in the mobile device 3/4 */}
          </div>
        </div>
        {/* FIRST CURVE - White */}
        <div className="absolute bottom-0 left-0 w-full z-10">
          <svg
            className="w-full h-auto"
            // viewBox="0 0 1440 320"
            viewBox="0 0 1440 290"
            preserveAspectRatio="none"
          >
            <path
              fill="#ffffff"
              fillOpacity="1"
              d="M0,160L60,165.3C120,171,240,181,360,165.3C480,149,600,107,720,117.3C840,128,960,192,1080,208C1200,224,1320,192,1380,176L1440,160L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
            />
          </svg>
        </div>

        {/* SECOND CURVE - Light Blue */}
        <div className="absolute bottom-[20px] left-0 w-full z-0">
          <svg
            className="w-full h-auto"
            viewBox="0 0 1440 320"
            preserveAspectRatio="none"
          >
            <path
              fill="#a6c7e2" // Light blue like in the image
              fillOpacity="1"
              d="M0,288L60,272C120,256,240,224,360,197.3C480,171,600,149,720,160C840,171,960,213,1080,208C1200,203,1320,149,1380,122.7L1440,96L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
            />
          </svg>
        </div>
      </div>

      {/* hero section */}

      {/* second web solution section */}
      <div className="">
        <h2 className="text-xl px-2 md:px-0 md:text-3xl font-bold text-center mt-4 mb-2 text-gray-600">
          SEO Services
        </h2>
        <div className="md:w-28 w-20 h-1 bg-main mx-auto md:mb-3 mb-1 rounded-full" />

        {/* Wrapper that allows scrolling */}
        <div className="px-  md:px-5 sm:px-3 grid grid-cols-1 md:grid-cols-1 lg:grid-cols-[2fr_1fr] gap-3 sm:gap-2 md:gap-8">
          {/* Main Content */}
          <div className="container mx-auto px-4 py-8">
            <div className="grid grid-cols-1 md:grid-cols-1 gap-8">
              {/* Image Section */}

              <div className="w-full md:order-1 order-2 max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
                <img
                  src={SEO}
                  alt="SEO"
                  className="w-full h-full  object-cover"
                />
              </div>

              {/* Text Content Section */}

              <div className="space-y-4 md:text-base text-sm order-2 md:order-1 text-justify">
                <p className="text-gray-700 leading-relaxed">
                  Search engine optimization (SEO) improve the quality and
                  quantity of website traffic to a website or a web page from
                  search engines. SEO make it possible for search engine to
                  understand your website’s content and connect it with users by
                  delivering relevant, valuable results based on their search
                  queries. The goal of SEO is to rank on the first page of
                  search engine results pages for the most relevant and valuable
                  keywords to your target demographic, driving qualified traffic
                  to your site.
                </p>
                <h3 className="text-xl font-semibold text-main md:text-2xl lg:text-3xl mt-4">
                  Our SEO Services Include:
                </h3>
                <div className=" max-w-7xl mx-auto">
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                    {services.map((service, index) => (
                      <div
                        key={index}
                        className="bg-white shadow-md border cursor-pointer rounded-xl p-6 text-center hover:shadow-xl transition duration-300"
                      >
                        <div className="text-orangeheading text-3xl mb-4">
                          <FontAwesomeIcon icon={service.icon} />
                        </div>
                        <h3 className="text-lg font-semibold text-gray-800">
                          {service.title}
                        </h3>
                      </div>
                    ))}
                  </div>
                </div>

                <p className="text-gray-700 leading-relaxed">
                  At <strong>Deetya Soft</strong>, we are committed to helping
                  your business achieve top rankings on major search engines
                  like <strong>Google, Bing, and Yahoo</strong>. With our expert
                  team and proven strategies, we ensure your business not only
                  reaches the first page but stays there, driving more traffic
                  and increasing conversions.
                </p>

                <p className="text-gray-700 leading-relaxed">
                  <strong>Ready to boost your online presence?</strong> Get in
                  touch with us today and let's build a custom SEO strategy that
                  drives real growth for your business.
                </p>
              </div>
            </div>
          </div>
          {/* Sticky Sidebar */}
          <div className="sticky  top-20 self-start  p-3  h-fit">
            <ServiceSide />
          </div>
        </div>

        {/* make it next section */}
      </div>
      <div
        className="py-5 px-5 relative"
        // data-aos='fade-up'
        style={{
          backgroundImage: `url(${BgImg})`,
          backgroundRepeat: "repeat",
          backgroundSize: "auto",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          minHeight: "60vh",
        }}
      >
        <div className="text-center py-10 px-4">
          <h2 className="text-3xl md:text-4xl font-extrabold">
            <span className="text-black">Our Power Packed </span>
            <span className="text-sky-500"> Feature</span>
          </h2>

          <div className="relative w-fit mx-auto mt-2">
            <div className="h-[1px] bg-gray-400 md:w-[200px] w-[100px] mx-auto"></div>
            <div className="absolute left-1/2 -translate-x-1/2 -top-[1px] flex gap-2">
              <div className="w-8 h-[2px] bg-sky-500"></div>
              <div className="w-8 h-[2px] bg-sky-500"></div>
            </div>
          </div>

          <p className="text-gray-800 text-base mt-4">
            What You Get Using Our Search Engine Optimiztion
          </p>
        </div>

        <div className="container mx-auto px-4 pb-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {pillars.map((pillar, index) => (
              <div
                key={index}
                className="bg-gray-50 shadow-md  overflow-hidden hover:shadow-lg transition-shadow duration-300"
              >
                <div className="p-8 text-center">
                  <div
                    className={`w-16 h-16 flex items-center justify-center rounded-full ${pillar.bgColor} mb-4 mx-auto`}
                  >
                    <FontAwesomeIcon
                      icon={pillar.icon}
                      className="text-sky-500 text-2xl"
                    />
                  </div>
                  <h5 className="md:text-lg text-base font-semibold text-gray-800 mb-3">
                    {pillar.title}
                  </h5>
                  <p className="text-gray-600 text-sm">{pillar.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* faq */}
      <div id="bottomTarget">
        <FaqSeo />
      </div>
      {/* client section */}
      <div>
        <OurClients />
      </div>
    </>
  );
}

export default SEOServices;
